<template>
    <app-modal-view @close="$emit('close')">
        <template #header>
            <div>
                <div class="is-mobile">
                    <p
                        v-t="'Sessions.new_session'"
                        class="is-size-5 has-text-centered has-text-weight-bold"
                    />
                </div>
            </div>
        </template>
        <template #body>
            <div class="lb-project-modal-content">
                <div v-if="showCreationWarning" class="notification is-warning">
                    <button
                        class="delete"
                        @click="showCreationWarning = false"
                    ></button>
                    <p v-t="'Sessions.creation_warning'"></p>
                </div>
                <div v-if="showCreationError" class="notification is-danger">
                    <button
                        class="delete"
                        @click="showCreationError = false"
                    ></button>
                    {{ creationError }}
                </div>
                <div
                    v-if="!$store.getters.projectContent.length"
                    class="notification is-danger"
                >
                    <p v-t="'Sessions.creation_empty_project'"></p>
                </div>

                <form action>
                    <div class="columns">
                        <div class="column is-6">
                            <div class="field mb-5">
                                <label
                                    v-t="'Sessions.session_name'"
                                    class="label"
                                ></label>
                                <div class="control">
                                    <input
                                        v-model="title"
                                        :placeholder="
                                            $t('Sessions.session_name')
                                        "
                                        class="input"
                                        type="text"
                                    />
                                </div>
                            </div>

                            <div class="field">
                                <label
                                    v-t="'Sessions.show_at_end'"
                                    class="label"
                                ></label>
                                <div class="control is-expanded">
                                    <textarea
                                        rows="3"
                                        v-model="configuration.feedback"
                                        :placeholder="
                                            $t('Sessions.end_of_game_info')
                                        "
                                        class="textarea has-fixed-size"
                                    ></textarea>
                                </div>
                            </div>

                            <!--<div class="field">
                                <label class="switch">
                                    <input id="appmode" v-model="configuration.app" type="checkbox" />
                                    <span class="slider round"></span>
                                </label>
                                <label v-t="'Sessions.app_mode'" for="appmode" class="pl-3"></label>
                            </div>-->
                        </div>
                        <div class="column is-6">
                            <label
                                v-t="'Sessions.play_mode_select'"
                                for="appmode"
                                class="label"
                            ></label>
                            <div class="level is-mobile mb-2">
                                <div class="level-item mr-0">
                                    <span
                                        ref="appButton"
                                        class="
                                            button
                                            is-light is-fullwidth
                                            has-tooltip-bottom
                                            has-tooltip-multiline
                                        "
                                        :data-tooltip="
                                            $t(`Sessions.play_mode_select_app`)
                                        "
                                        @click.stop="setApp"
                                    >
                                        <span class="icon is-small">
                                            <i
                                                class="
                                                    mdi
                                                    mdi-18px
                                                    mdi-tablet-cellphone
                                                "
                                            ></i>
                                        </span>
                                        <span>APP</span>
                                    </span>
                                </div>
                                <div class="level-item mr-0">
                                    <span
                                        ref="webButton"
                                        class="
                                            button
                                            is-light is-primary is-fullwidth
                                            has-tooltip-bottom
                                            has-tooltip-multiline
                                        "
                                        :data-tooltip="
                                            $t(`Sessions.play_mode_select_web`)
                                        "
                                        @click.stop="setWeb"
                                    >
                                        <span class="icon is-small">
                                            <i
                                                class="mdi mdi-18px mdi-laptop"
                                            ></i>
                                        </span>
                                        <span>WEB</span>
                                    </span>
                                </div>
                            </div>

                            <label
                                v-if="configuration.app"
                                v-t="'Sessions.play_mode_select_app_hint'"
                                for="appmode"
                                class="label is-italic"
                            ></label>
                            <label
                                v-else
                                v-t="'Sessions.play_mode_select_web_hint'"
                                for="appmode"
                                class="label is-italic"
                            ></label>

                            <div class="field mb-3 pt-4" v-if="isModeMap">
                                <label class="switch">
                                    <input
                                        id="closer"
                                        v-model="configuration.closer"
                                        type="checkbox"
                                    />
                                    <span class="slider round"></span>
                                </label>
                                <label
                                    v-t="'Sessions.have_to_be_close'"
                                    for="closer"
                                    class="pl-3"
                                ></label>
                            </div>

                            <div class="field pt-4">
                                <label class="switch">
                                    <input
                                        id="allowsReset"
                                        v-model="allowsReset"
                                        type="checkbox"
                                    />
                                    <span class="slider round"></span>
                                </label>
                                <label
                                    v-t="'Sessions.allows_reset'"
                                    for="allowsReset"
                                    class="pl-3"
                                ></label>
                            </div>

                            <!--<div class="field">
                                <label
                                    v-t="'Sessions.show_at_end'"
                                    class="label"
                                ></label>
                                <div class="control is-expanded">
                                    <textarea
                                        rows="3"
                                        v-model="configuration.feedback"
                                        :placeholder="
                                            $t('Sessions.end_of_game_info')
                                        "
                                        class="textarea has-fixed-size"
                                    ></textarea>
                                </div>
                            </div>-->
                        </div>
                    </div>

                    <hr />

                    <div class="columns">
                        <div class="column is-6 pb-0">
                            <div class="field mb-3 mt-3">
                                <label class="switch">
                                    <input
                                        id="availability"
                                        v-model="configuration.availability"
                                        type="checkbox"
                                    />
                                    <span class="slider round"></span>
                                </label>
                                <label
                                    v-t="'Sessions.game_availability'"
                                    for="availability"
                                    class="pl-3"
                                ></label>
                            </div>
                        </div>
                    </div>

                    <div class="columns" v-if="limitedAvailability">
                        <div class="column is-6 pt-0">
                            <div class="field mb-5">
                                <label
                                    v-t="'Sessions.start_date'"
                                    class="label"
                                ></label>
                                <div class="field-body">
                                    <InputDatetime
                                        v-model="configuration.startDate"
                                        :min-date="minDate"
                                    ></InputDatetime>
                                </div>
                            </div>
                        </div>

                        <div class="column is-6 pt-0">
                            <div class="field mb-5">
                                <label
                                    v-t="'Sessions.limit_date'"
                                    class="label"
                                ></label>
                                <div class="field-body">
                                    <InputDatetime
                                        v-model="configuration.limitDate"
                                        :min-date="minDate"
                                    ></InputDatetime>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </template>

        <template #footer>
            <div class="lb-project-modal-footer">
                <button
                    v-if="$store.getters.projectContent.length"
                    v-t="'Sessions.create'"
                    :class="{ 'is-loading': creating }"
                    class="button is-primary is-uppercase pl-6 pr-6"
                    @click="createSession"
                />
            </div>
        </template>
    </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
import { createItem } from '@/services/API';
import InputDatetime from '@/components/InputDatetime';
import moment from 'moment';
import _ from 'underscore';
export default {
    components: {
        AppModalView,
        InputDatetime,
    },
    data() {
        return {
            creating: false,
            allowsReset: false,
            showCreationWarning: true,
            showCreationError: false,
            creationError: false,
            minDate: moment().toISOString(),
            configuration: {
                mode: this.isModeMap != true ? 'TRIVIAL' : 'MAP',
                time: 2,
                timeUnits: 'minutes',
                closer: false,
                availability: false,
                app: false,
                web: true,
            },
            title: this.$store.getters.project.type=='treasurehunt' ? this.$t('Sessions.treasurehunt_title_suggestion') + this.$store.getters.project.title : this.$t('Sessions.quiz_title_suggestion') + this.$store.getters.project.title,
        };
    },
    computed: {
        isTrivial() {
            return this.$store.getters.project.type == 'trivial';
        },
        objects() {
            return this.$store.getters.projectContent;
        },
        limitedAvailability() {
            return this.configuration.availability;
        },
        isModeMap() {
            return this.$store.getters.project.mode == 'map';
        },
    },
    methods: {
        async createSession() {
            this.creating = true;
            this.showCreationError = false;
            this.creationError = undefined;
            if (this.isModeMap == true && this.isTrivial) {
                const objectsContainsLocation = _.every(
                    this.objects,
                    (object) => {
                        return object.location;
                    }
                );
                if (!objectsContainsLocation) {
                    this.showCreationError = true;
                    this.creating = false;
                    return (this.creationError = this.$t(
                        'Sessions.error_objects_without_location'
                    ));
                }
                if (this.configuration.mode == 'TRIVIAL') {
                    console.log('forcing change');
                    this.configuration.mode = 'MAP';
                }
            }
            let session = await createItem('session', {
                configuration: this.configuration,
                project: this.$store.getters.project._id,
                title: this.title,
                shortCode: this.code,
                allowsReset: this.allowsReset,
            });
            this.creating = false;
            this.$store.dispatch('setSession', session.data).catch((e) => {
                this.creating = false;
                this.creationError = e;
                this.showCreationError = true;
            });
            this.$emit('detail');
            this.$emit('close');
        },
        setApp() {
            this.configuration.app = true;
            this.configuration.web = false;
            if (!this.$refs.appButton.classList.contains('is-primary')) {
                this.$refs.appButton.classList.add('is-primary');
                this.$refs.webButton.classList.remove('is-primary');
            }
        },
        setWeb() {
            this.configuration.app = false;
            this.configuration.web = true;
            if (!this.$refs.webButton.classList.contains('is-primary')) {
                this.$refs.webButton.classList.add('is-primary');
                this.$refs.appButton.classList.remove('is-primary');
            }
        },
    },
};
</script>

<style scoped>
.lb-project-modal-footer {
    margin: 0 auto;
}
</style>
